 import * as Yup from 'yup';
export const tasaValidationSchema = Yup.object().shape({
    id: Yup.number()
        .required('El ID es obligatorio')
        .typeError('El ID debe ser un número válido'),

 
});

export const validateTasaForm = async (formData) => {
    try {
        await tasaValidationSchema.validate(formData, { abortEarly: false });
        return {};
    } catch (error) {
        const errors = {};
        if (error.inner) {
            error.inner.forEach((err) => {
                errors[err.path] = err.message;
            });
        }
        return errors;
    }
};
 
 